import type { DiskAncestor } from '../Contracts/DiskNode'

/**
 * Шлях вузла для показу «де лежить» (результати пошуку, нещодавні): `ancestors`
 * беку — простір і папки від кореня до батька (`NodeAncestors`).
 */

/** Скільки сегментів показати без згортання: «Простір / … / Передостання / Батьківська». */
export const DISK_PATH_MAX_SEGMENTS = 4

export const DISK_PATH_SEPARATOR = ' / '

/**
 * Назви сегментів; корінь — підписом простору, як у навігації («Мій диск»
 * замість назви особистого простору).
 */
export const diskPathNames = (ancestors: readonly DiskAncestor[] | null, rootTitle?: string | null): string[] =>
    (ancestors ?? []).map((segment) => (segment.root && rootTitle ? rootTitle : segment.name))

/** Повний шлях текстом — для підказки й `title`. */
export const diskPathText = (names: readonly string[]): string => names.join(DISK_PATH_SEPARATOR)

/**
 * Довгий шлях згортається посередині: перший сегмент (простір), «…», останні
 * — щоб було видно і де простір, і в якій саме папці файл.
 */
export const collapseDiskPath = (names: readonly string[], max = DISK_PATH_MAX_SEGMENTS): string[] =>
    names.length <= max ? [...names] : [names[0] ?? '', '…', ...names.slice(names.length - (max - 2))]
